<template>
  <v-snackbar
      v-model="show"
      :timeout="6000"
      color="primary"
      elevation="24"
  >
    {{ t('snacks.downloaded') }}
  </v-snackbar>
</template>

<script>
import { useI18n } from "vue-i18n";
export default {
  props:{
    visible: {
      type: Boolean,
      Required: true
    }
  },
  setup() {
    const { t } = useI18n();

    return {
      t
    };
  },
  data(){
    return {
      show: false,
    }
  },
  watch:{
    visible(newVal){
      this.show = newVal;
    }
  }
}
</script>